import React from "react";
import SkeletonC from "./SkeletonC";

const SkeletonApartmentListItemRow = () => {
    return (

        <div className="col-12 apartment-list-item-row">
            <div className="row inner skeleton">
                <SkeletonC skeletonThemeProps={{ height: "100%" }} skeletonProps={{ height: "100%",  width:"100vw" }} />
            </div>
        </div>
    )
}

export default SkeletonApartmentListItemRow;